module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_48.7799cd96.png";